import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ObservatoryService, StorageService, UserService } from '@services/services.module';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ROL_TYPE } from '@app/constants/enums';

@Component({
  selector: 'app-distribuidora',
  templateUrl: './distribuidora.component.html',
  styleUrls: ['./distribuidora.component.scss']
})
export class DistribuidoraComponent implements OnInit, AfterViewInit {

  public userDataStorage: any;
  public showAdminOrDirection = false;
  public showAdminDirectionManagerOperations = false;
  public isAdmin: boolean;
  public isDirection: boolean;

  constructor(
    private titleService: Title,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private observatory: ObservatoryService,
    private storage: StorageService,
    private _user: UserService
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
  }

  ngAfterViewInit(): void {
    this.userControl();
    this.userControlInfo();
  }

  routeTo(route) {
    this._router.navigate([route]);
  }

  userControl(): void {
    this._user.checkRolType([ROL_TYPE.admin, ROL_TYPE.direction]).then((data: any) => {
      this.isAdmin = data.value;
      if (this.isAdmin) {
        this.showAdminOrDirection = true;
      }
    });
  }

  userControlInfo(): void {
    this._user.checkRolType([ROL_TYPE.admin, ROL_TYPE.direction, ROL_TYPE.manager, ROL_TYPE.operations]).then((data: any) => {
      if (data.value) {
        this.showAdminDirectionManagerOperations = true;
      }
    });
  }

}
